import HttpRequest from "../../../../../Common/Http/HttpRequest";

export const getTableDataV2 = ({pageIndex, pageSize, sortBy, filters, baseEndpoint, customizeResponseData}) => {

    const params = new URLSearchParams();
    getSortList(params, sortBy);

    processFilter(params, filters);

    params.append('page', pageIndex);
    params.append('size', pageSize);
    const separator = getSeparator(baseEndpoint);
    const url = `${baseEndpoint}${separator}${params.toString()}`
    return doRequest(url, pageSize, customizeResponseData);

};

const getFilterValue = (value) => {
    if (value instanceof Date) {
        if (value.onlyDate) {
            return value.toLocaleDateString();
        }
        return value.toISOString();
    }

    return value;
}
const processFilter = (query, filters) => {
    filters && filters.forEach((x) => {

        if (x.id === "duracao") {
            query.append("_startDate", getFilterValue(x.value[0]));
            query.append("_endDate", getFilterValue(x.value[1]));
        } else {
            if (Array.isArray(x.value)) {
                x.value.forEach(y => {
                    const value = getFilterValue(y);
                    value && query.append(x.id, value);
                });
            } else {
                query.append(x.id, getFilterValue(x.value));
            }

        }
    })
}

const getSortList = (params, sortBy) => {
    sortBy.forEach(x => {
        const sentido = x.desc ? 'DESC' : 'ASC';
        params.append('sort', `${x.id},${sentido}`);
    });
}

const getSeparator = (url) => {
    return url.indexOf('?') === -1 ? `?` : '&'
}

const doRequest = async (url, pageSize, customizeResponseData) => {
    const response = await HttpRequest.get(url);
    console.log('response', response);

    if (customizeResponseData) {
        return customizeResponseData(response)
    }

    let content = response.data;
    let totalElements = response.pagination.total;
    const totalPages = response.pagination.totalPages;


    return {content, pageCount: totalPages, totalElements, totalPages: response.pagination.totalPages};
}
